/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_With_Email_ButtonInputs */



/**
* | output |
* | --- |
* | "Continue with email" |
*
* @param {Login_Continue_With_Email_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_continue_with_email_button = /** @type {((inputs?: Login_Continue_With_Email_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_With_Email_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec l'email")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit der E-Mail fortfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua con l'email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить отправку электронного письма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar con el correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续通过电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールで続行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल के साथ जारी रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar com o e-mail")
	return /** @type {LocalizedString} */ ("Continue with email")
});